import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const productJsonByHandle = new Map();

function getAttrs(result) {
  return result?.attributes || result?.display?.attributes || {};
}

function getVariantIds(result) {
  const attrs = getAttrs(result);
  const raw =
    attrs.variant_id ??
    attrs.ss_variant_id ??
    attrs.shopify_variant_id ??
    attrs.variant_ids;
  if (raw == null || raw === '') return [];
  if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
  if (typeof raw === 'string') {
    return raw
      .split(/[|,]/)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [String(raw)];
}

function getVariantSkuCount(result) {
  const attrs = getAttrs(result);
  const sku = attrs.variant_sku;
  if (sku == null || sku === '') return 0;
  if (Array.isArray(sku)) return sku.filter(Boolean).length;
  if (typeof sku === 'string') {
    return sku
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean).length;
  }
  return 1;
}

function isDefinitelyMultiFromIndex(result) {
  if (getVariantSkuCount(result) > 1) return true;
  if (getVariantIds(result).length > 1) return true;
  return false;
}

function productHandleFromUrl(productUrl) {
  if (!productUrl || typeof productUrl !== 'string') return '';
  const m = productUrl.match(/\/products\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

function loadProductJson(handle) {
  if (!handle) return Promise.resolve(null);
  if (productJsonByHandle.has(handle)) return productJsonByHandle.get(handle);
  const p = fetch(`/products/${encodeURIComponent(handle)}.js`)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((product) => {
      if (product == null) {
        productJsonByHandle.delete(handle);
      }
      return product;
    });
  productJsonByHandle.set(handle, p);
  return p;
}

export function WcRecsCardFooter({ result }) {
  const core = result?.mappings?.core;
  const url = core?.url;
  const [cta, setCta] = useState(null);

  useEffect(() => {
    if (!url) {
      setCta('skip');
      return;
    }
    if (isDefinitelyMultiFromIndex(result)) {
      setCta('view-all');
      return;
    }
    const handle = productHandleFromUrl(url);
    if (!handle) {
      setCta('view-all');
      return;
    }
    let cancelled = false;
    loadProductJson(handle).then((product) => {
      if (cancelled) return;
      if (!product?.variants?.length) {
        setCta('view-all');
        return;
      }
      if (product.variants.length > 1) {
        setCta('view-all');
        return;
      }
      const variant = product.variants[0];
      if (!variant.available) {
        setCta('sold-out');
        return;
      }
      setCta({ addId: String(variant.id) });
    });
    return () => {
      cancelled = true;
    };
  }, [result, url]);

  if (!url || cta === 'skip') return null;

  if (cta === null) return null;

  if (cta === 'view-all') {
    return (
      <a href={url} class="button button--secondary button--small wc-recs-card__cta">
        View All
      </a>
    );
  }

  if (cta === 'sold-out') {
    return (
      <button type="button" disabled class="button button--secondary button--small wc-recs-card__cta">
        Sold Out
      </button>
    );
  }

  if (cta?.addId) {
    return (
      <button
        type="button"
        class="button button--secondary button--small js-add-to-cart wc-recs-card__cta"
        data-variant-id={cta.addId}
      >
        Add to Cart
      </button>
    );
  }

  return null;
}
